import {
	Popconfirm
}from "antd"
import React, {
	useEffect,
	useState
}from "react"
import {
	useDispatch
}from "react-redux"
import {
	Link
}from "react-router-dom"
import {
	helpSectionActions
}from "../store/actions"
import './style.css'
import DeleteIcon from '../../../components/Icons/delete.svg'
import RestoreIcon from '../../../components/Icons/restore.svg'
import EditIcon from '../../../components/Icons/update.svg'
import PlusIcon from '../../../components/Icons/whitePlus.svg'
import DoneIcon from '../../../components/Icons/done.svg'
import CustomInput from "../../../components/CustomInput"
import Notifications from "../../../helpers/Notifications"

const HelpTagCard = ({ isModify, tag, setIsCreateNewTag, setIsVisibleModalCreateHelp, setChangeableHelp, isEmptyTag, setHelpTag }) => {
	const [isEdit, setIsEdit] = useState(!tag)
	const [tagName, setTagName] = useState(tag?.name)

	const dispatch = useDispatch()

	const updateHelpTag = (params) => {
		dispatch(helpSectionActions.updateHelpTag(params))
	}

	const createHelpTag = (params) => {
		dispatch(helpSectionActions.createHelpTag(params))
	}

	const restoreHelpTag = (params) => {
		dispatch(helpSectionActions.restoreHelpTag(params))
	}

	const deleteHelpTag = (params) => {
		dispatch(helpSectionActions.deleteHelpTag(params))
	}

	const deleteHelp = (params) => {
		dispatch(helpSectionActions.deleteHelp(params))
	}

	const restoreHelp = (params) => {
		dispatch(helpSectionActions.restoreHelp(params))
	}

	const modifyTag = () => {
		if (tagName?.trim()){
			if (tag){
				tag.name !== tagName
					? updateHelpTag({
						id   : tag.id,
						name : tagName
					})

					: null
			}

			else {
				createHelpTag({
					name: tagName
				})
				setIsCreateNewTag(false)
			}
			setIsEdit(false)
		}
		else
			Notifications.warningNotice("Требуется название тега для его добавления/изменения.", null, 15)
	}

	const linkIcon = (
		<svg
			className="help-tag-link-icon"
			fill="#002762"
			height="12px"
			viewBox="0 0 7 12"
			width="7px"
			xmlns="http://www.w3.org/2000/svg"
			onClick={ modifyTag }
		>
			<path d="M5.83327 4.23243L2.00911 0.410763C1.85043 0.267295 1.64267 0.19034 1.42882 0.195832C1.21498 0.201323 1.01143 0.288839 0.860333 0.440261C0.709232 0.591683 0.622148 0.795412 0.617111 1.00927C0.612074 1.22312 0.68947 1.43073 0.833274 1.5891L4.65494 5.41076C4.81117 5.56704 4.89893 5.77896 4.89893 5.99993C4.89893 6.2209 4.81117 6.43282 4.65494 6.5891L0.833274 10.4108C0.677017 10.5671 0.589277 10.7792 0.589356 11.0002C0.589434 11.2213 0.677324 11.4333 0.833691 11.5895C0.990058 11.7458 1.20209 11.8335 1.42315 11.8334C1.64421 11.8334 1.85618 11.7455 2.01244 11.5891L5.83327 7.76743C6.30195 7.29861 6.56524 6.66284 6.56524 5.99993C6.56524 5.33702 6.30195 4.70125 5.83327 4.23243Z" />
		</svg>
	)

	const handleChangeTag = (e) => {
		setTagName(e.target.value)
	}

	const onDeleteHelpTag = () => {
		if (tag){
			if (tag.isDeleted){
				restoreHelpTag({
					id: tag.id
				})
			}
			else {
				deleteHelpTag({
					id: tag.id
				})
			}
		}
		else
			setIsCreateNewTag(false)
	}

	const onDeleteHelp = (item) => {
		if (item.isDeleted){
			restoreHelp({
				id: item.id
			})
		}
		else {
			deleteHelp({
				id: item.id
			})
		}
	}

	const handleCloseEdit = (e) => {
		if (e.keyCode == 27){
			setIsEdit(false)
			setTagName(tag?.name)
			setIsCreateNewTag(false)
		}
	}

	const handleEditHelp = (elem) => {
		setChangeableHelp(elem)
		setIsVisibleModalCreateHelp(true)
	}

	return (
		<div className="help-tag-card">
			<div className="help-tag-card-title">
				<div className="help-tag-title-text">
					{ !isEdit
						? tagName
						: (<CustomInput
							defaultValue={ tagName }
							value={ tagName }
							onChange={ handleChangeTag }
							onKeyDown={ handleCloseEdit }
							onPressEnter={ modifyTag }
						   />) }
				</div>
				{ isModify
					? (isEdit
						? (<img
							className="help-tag-edit-icon"
							src={ DoneIcon }
							title="Сохранить"
							onClick={ modifyTag }
						   />)
						: (<img
							className="help-tag-edit-icon"
							src={ EditIcon }
							title="Редактировать название тега"
							onClick={ (e) => {
								e.stopPropagation()
								setIsEdit(true)
							} }
						   />))
					: null }
				{ isModify
					? (<Popconfirm
						cancelText="Нет"
						okText="Да"
						title={ `Вы действительно хотите ${ tag?.isDeleted ?"восстановить" :"удалить" } тег?` }
						onCancel={ (e) => {
							return
						} }
						onConfirm={ onDeleteHelpTag }
					   >
						<img
							className="help-tag-delete-icon"
							src={ tag?.isDeleted ? RestoreIcon: DeleteIcon }
							title={ tag?.isDeleted ? 'Восстановить тег' : 'Удалить тег' }

						/>
					</Popconfirm>)
					: null }
			</div>
			<div className="help-tag-card-items">
				{ tag?.helps.map((elem) => {
					return !elem.isDeleted || isModify
						? (<div
							key={ elem.id }
				    className="help-card-item"
						   >
							<Link
								className="help-item-link"
								to={ `/help/${ elem.id }` }
							>
								{ linkIcon }
								{ elem.title }
							</Link>
							{ isModify
								? (<>
									<img
										className="help-edit-icon"
										src={ EditIcon }
										title="Редактировать статью"
										onClick={ (e) => {
											e.preventDefault()
											handleEditHelp(elem)
										} }
									/>
									<Popconfirm
										cancelText="Нет"
										okText="Да"
										title={ `Вы действительно хотите ${ elem?.isDeleted ? "восстановить" :"удалить" } статью?` }
										onCancel={ (e) => {
											return
										} }
										onConfirm={ () => {
											onDeleteHelp(elem)
										} }
									>
										<img
											className="help-delete-icon"
											src={ elem?.isDeleted ? RestoreIcon : DeleteIcon }
											title={ `${ elem?.isDeleted ? "Восстановить" : "Удалить" } статью` }
										/>
									</Popconfirm>
								</>)
								: null }
						</div>)
						: null
				}) }
				{ isModify && !isEmptyTag && !tag.isDeleted
					? (<button
						className="button-add-helps"
						onClick={ () => {
							setIsVisibleModalCreateHelp(true)
							setHelpTag(tag.id.toString())
						} }
					   >
						<img src={ PlusIcon }></img>
					</button>)
					: null }
			</div>
		</div>)
}

export default HelpTagCard